module.exports = __webpack_public_path__ + "img/proImg6.1d2f71db.png";